import * as ExploreApiService from '../services/api/requests/Explore'

export const doGetFeatureStatuses = ({ setFeatureStatus }) => {
  ExploreApiService.getFeatureStatus().then(response => {
    setFeatureStatus(response.data)
  })
}
